import React, { useState } from 'react'
import { Spin } from 'antd'
const SpinContext = React.createContext({
  spinning: false,
  setSpinning: () => null,
})

export const SpinContextProvider = ({
  children,
  initLoadingDataStatus,
  unitLoadingStatus,
}) => {
  const [spinning, setSpinning] = useState(false)

  return (
    <SpinContext.Provider value={{ spinning, setSpinning }}>
      <Spin spinning={initLoadingDataStatus || unitLoadingStatus || spinning}>
        {children}
      </Spin>
    </SpinContext.Provider>
  )
}

export default SpinContext
